import * as React from 'react';
import { Content, Heading, LightTooltip } from './StylovyzeTooltip.styles';
/**
 * Styled MUI Tooltip
 */
export const StylovyzeTooltip = ({ heading, content, title, ...otherProps }) => {
    return (React.createElement(LightTooltip, { ...otherProps, title: title || (React.createElement(React.Fragment, null,
            heading && React.createElement(Heading, null, heading),
            React.createElement(Content, null, content))) }));
};
StylovyzeTooltip.defaultProps = {};
export default StylovyzeTooltip;
